/*global gapi*/
import { googleApiInitializer } from 'helpers/social'
import config from 'config'

function loadAuth2() {
	return new Promise(function(resolve) {
		gapi.load('client:auth2', resolve)
	})
}

function initializeGapiAuth() {
	return gapi.auth2.init({
		clientId: config.googleDrive.clientId,
		fetchBasicProfile: false,
		scope: config.bytebot.scope,
	})
}

function initLicense(access_token) {
	const API_KEY = config.googleDrive.developerKey
	const gapiValues = {
		apiKey: API_KEY,
		discoveryDocs: [
			`https://bytebot.googleapis.com/$discovery/rest?version=v1&key=${API_KEY}`,
		],
		scope: 'https://www.googleapis.com/auth/applicense.bytebot',
	}
	if (access_token) {
		gapi.client.setToken({access_token})
	}
	return gapi.client.init(gapiValues)
}

function getGoogleUserId() {
	const GoogleAuth = gapi.auth2.getAuthInstance()
	if (GoogleAuth.isSignedIn.get()) {
		const profile = GoogleAuth.currentUser.get().getBasicProfile()
		return Promise.resolve(profile.getId())
	} else {
		return Promise.reject('getGoogleUserId promise rejected')
	}
}

function claimLicense() {
	const licenseStatusRequest = {name: config.bytebot.appName}
	return gapi.client.bytebot.applications.getLicenseStatus(licenseStatusRequest)
		.then(
			response => {
				const status = response.result.status
				if (status === 'ACTIVE') {
					return Promise.resolve(true)
				} else {
					return Promise.reject()
				}
			})
}

export default function checkLicense(access_token) {
	let licenseId
	if (!access_token) { // user already associated in nearpod with a bytebot id or just created on the fly
		return googleApiInitializer() // initializes the google api if is not already
			.then(loadAuth2) // we load auth2 client module in the google api
			.then(initializeGapiAuth) // we add to auth2 the scope of bytebot
			.then(() => initLicense()) // we init bytebot with no access_token
			.then(getGoogleUserId) // we get the google user id of current user
			.then(_licenseId => licenseId = _licenseId)
			.then(claimLicense) // we claim the status of that license
			.then(() => licenseId) // if license is active we return it
	} else { // user just registered in nearpod with google sso
		return googleApiInitializer()
			.then(loadAuth2)
			.then(initializeGapiAuth)
			.then(() => initLicense(access_token))
			.then(claimLicense)
			.then(() => licenseId)
	}
}
